/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApplicationOption } from "../types";

export type SelectorProps = {
  onClear?: () => void;
  onChange: (apps: string[], envs: string[]) => void;
  applications: ApplicationOption[];
  selectedApplications: string[];
  selectedEnvironments: string[];
  loading: boolean;
  selectionType?: SELECTOR_TYPE;
  onlyEnvironments?: boolean;
};

export type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
  onChange: (apps: string[], envs: string[]) => void;
  applications: ApplicationOption[];
  selectedEnvs: Option[];
  setSelectedEnvs: React.Dispatch<React.SetStateAction<Option[]>>;
  selectedApps: Option[];
  setSelectedApps: React.Dispatch<React.SetStateAction<Option[]>>;
  loading: boolean;
  selectionType?: SELECTOR_TYPE;
  onlyEnvironments?: boolean;
  disabled?: boolean;
};

export type AppEnvTableProps = {
  filteredApps: ApplicationOption[];
  selectedEnvs: Option[];
  setSelectedEnvs: React.Dispatch<React.SetStateAction<Option[]>>;
  selectedApps: Option[];
  setSelectedApps: React.Dispatch<React.SetStateAction<Option[]>>;
  selectionType?: SELECTOR_TYPE;
  disabled?: boolean;
};

export enum SELECTOR_TYPE {
  checkbox,
  switch,
}

export type AppEnvRowProps = {
  name: string;
  nid: string;
  environments: ApplicationOption["environments"][number][];
  selectedEnvs: Option[];
  setSelectedEnvs: React.Dispatch<React.SetStateAction<Option[]>>;
  selectedApps: Option[];
  setSelectedApps: React.Dispatch<React.SetStateAction<Option[]>>;
  selectionType?: SELECTOR_TYPE;
  disabled?: boolean;
};

export type Option = {
  name: string;
  nid: string;
};

export type SelectAppEnvFormData = {
  applicationId: string;
  environmentId: string;
};
